import React, {useEffect, useState} from 'react'
import Parser from 'rss-parser'

import BButton from 'components/Form/Fields/BButton'

const rssFeedUrl = 'https://buildiro.com/blog/feed/'
export const buildiroBlogUrl = 'https://buildiro.com/blog/'

const LandingBlog = ({t}) => {
  const [data, setData] = useState(undefined)

  useEffect(() => {
    new Parser().parseURL(rssFeedUrl).then(d => void setData(d?.items?.slice(0, 3)))
  }, [])

  return (
    <div id='blog'>
      <div>
        <div className='blog-head'>
          <a href={buildiroBlogUrl} target='_blank' rel="noopener noreferrer">
            <BButton bordered>
              {t('SHOW')} <b>{t('MORE POSTS')}</b>
            </BButton>
          </a>

          <h1>
            {t('Latest news')}<br/>
            <b>{t('from Buildiro blog')}</b>
          </h1>
        </div>

        <div className='blog-content'>
          {data ? (
            data.map(e => (
                <a key={e.link} href={e.link} target='_blank' rel="noopener noreferrer">
                  <div>
                    <BButton>{t('READ MORE')}</BButton>
                  </div>

                  <div>
                    <h5>{e.title}</h5>
                    <i>{new Date(Date.parse(e.pubDate)).toLocaleDateString(t('toLocaleDateString'))}</i>

                    <p>{e.content}</p>
                  </div>
                </a>
              ))
            ) : data === undefined ? (
            'loading...'
          ) : (
            'error'
          )}
        </div>
      </div>
    </div>
  )
}

export default LandingBlog
